import { FaInstagram, FaTiktok, FaYoutube, FaXTwitter, FaTelegram, FaFacebook, FaThreads, FaLinkedin, FaSpotify, FaTwitch, FaSnapchat, FaDiscord } from "react-icons/fa6";

const ICONS = [
  { Icon: FaInstagram, label: "Instagram", color: "#E1306C" },
  { Icon: FaTiktok, label: "TikTok", color: "#ffffff" },
  { Icon: FaYoutube, label: "YouTube", color: "#FF0000" },
  { Icon: FaXTwitter, label: "X", color: "#ffffff" },
  { Icon: FaTelegram, label: "Telegram", color: "#29A9EA" },
  { Icon: FaFacebook, label: "Facebook", color: "#1877F2" },
  { Icon: FaThreads, label: "Threads", color: "#ffffff" },
  { Icon: FaLinkedin, label: "LinkedIn", color: "#0A66C2" },
  { Icon: FaSpotify, label: "Spotify", color: "#1DB954" },
  { Icon: FaTwitch, label: "Twitch", color: "#9146FF" },
  { Icon: FaSnapchat, label: "Snapchat", color: "#FFFC00" },
  { Icon: FaDiscord, label: "Discord", color: "#5865F2" },
];

export function SocialMarquee() {
  const items = [...ICONS, ...ICONS];
  return (
    <div className="marquee-wrap overflow-hidden py-6 relative" data-testid="social-marquee">
      <div className="absolute left-0 top-0 bottom-0 w-16 z-10 bg-gradient-to-r from-[#1f222d] to-transparent" />
      <div className="absolute right-0 top-0 bottom-0 w-16 z-10 bg-gradient-to-l from-[#1f222d] to-transparent" />
      <div className="marquee-track gap-4">
        {items.map(({ Icon, label, color }, i) => (
          <div key={i} className="flex items-center gap-3 shrink-0 card-surface px-5 py-3">
            <Icon size={26} style={{ color }} />
            <span className="text-sm font-semibold text-gray-200 whitespace-nowrap">{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
